import gettext from '@sdk/lang/gettext';

import { Wrapper } from './textEditorDisabled.styles';

type Props = {
  withInactiveUser: boolean;
};

const TextEditorDisabled = ({ withInactiveUser }: Props) => {
  const title = withInactiveUser
    ? gettext('This user is no longer a member of this company')
    : gettext('Your workplace admins have restricted who can post to this conversation');

  return <Wrapper>{title}</Wrapper>;
};

export default TextEditorDisabled;
